var SortData = function (processedData) {

  var result = {};
  for (var j = 0; j < processedData.length; j++) {

      var obj = processedData[j];
      var key = "legendKey";
      var value = obj[key];
      // delete obj[key];

      var polje = result[value];
      if (polje == null) {
          polje = [];
      }
      polje.push(obj);
      result[value] = polje;

  }
  //console.log("resultobj",result);
  return result;
}

exports.SortData=SortData;



//////////////////
// WEBPACK FOOTER
// ./src/modules/SortData/SortData.js
// module id = 13
// module chunks = 0